import { B4_FORM_INITIAL_VALUES as B4_FORM_INITIAL_VALUES_SHARED } from 'shared'

export const B4_FORM_INITIAL_VALUES = B4_FORM_INITIAL_VALUES_SHARED

export type B4FormValues = typeof B4_FORM_INITIAL_VALUES
